import styled from '@emotion/styled'
import mq from 'theme/mediaQueries'

export const ThreeFields = styled.div`
  grid-template-columns: 200px 200px 200px;
  column-gap: 20px;

  ${mq({
    display: ['block', 'block', 'grid'],
  })}
`

export const TwoFields = styled.div`
  grid-template-columns: 310px 310px;
  column-gap: 20px;

  ${mq({
    display: ['block', 'block', 'grid'],
  })}
`
